import React, { memo } from 'react'
import { Skeleton } from 'transfix-ui/core'
import { InlineRow } from 'apps/fleet-planner/components/load-details/InlineRow'
import { LockedTooltip } from 'apps/fleet-planner/components/load-details/LockedTooltip'
import { DISPLAY } from 'constants/display'

interface IExternalInstructionsDisplayProps {
  name: string
  value?: string
  isLoading?: boolean
}

export const ExternalInstructionsDisplay = memo<IExternalInstructionsDisplayProps>(
  ({ isLoading, name, value }) => {
    return (
      <InlineRow
        rowTitle={name}
        rowBody={
          <div className='inline-edit-container locked'>
            {isLoading ? (
              <Skeleton variant='rectangular' height={20} width={190} />
            ) : (
              <>
                <LockedTooltip className='locked-icon' />
                {value || DISPLAY.empty}
              </>
            )}
          </div>
        }
      />
    )
  }
)
